import React, { Component } from "react";
import Selector from "../../components/dropdown/commonDropdown/Selector";
import Table from "../../components/table/Table";
import BookingServices from "../../services/axiosServices/apiServices/BookingServices";
import ModalBasic from "../component/FormModal";
import moment from "moment";
import SwalServices from "../../services/swalServices/SwalServices";
import { APIURL, GetImage } from "../../services/axiosServices/ApiEndPoints";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import {
  CommonValidationMessages,
  CommonSuccessMessages,
} from "../../utils/Messages";
import ValidationText from "../../utils/validation/ValidationText";
import EntryManagementServices from "../../services/axiosServices/apiServices/EntryManagementServices";
import ActionDeleteButton from "../../components/UIComponent/ActionTableComponent/ActionDeleteButton";
import CommonServices from "../../services/axiosServices/apiServices/CommonServices";
import DtsmeServices from "../../services/axiosServices/apiServices/DtsmeServices";
import ButtonLoader from "../../components/common/buttonLoader/ButtonLoader";
import DropdownSelect from "../../components/dropdown/Dropdown";
import { saveAs } from "file-saver";
import MTOServices from "../../services/axiosServices/apiServices/MTOServices";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../components/dropdown/DropdownAction";
import { getAuditContext } from "../../utils/AuthenticationLibrary";

export default class PaymentReconcilation extends Component {
  constructor(props) {
    super(props);
    this.BookingServices = new BookingServices();
    this.entryServices = new EntryManagementServices();
    this.swalServices = new SwalServices();
    this.commonServices = new CommonServices();
    this.dtsmeServices = new DtsmeServices();
    this.mtoServices = new MTOServices();
    this.state = {
      isExceluploading: false,
      statusList: [
        {
          value: 1,
          label: "Pending Approval",
        },
        {
          value: 2,
          label: "Completed",
        },
        {
          value: 3,
          label: "Approved",
        },
        {
          value: 4,
          label: "Rejected",
        },
      ],
      paymentCategory: [
        {
          value: 1,
          label: "Event",
        },
        {
          value: 2,
          label: "Membership",
        },
        {
          value: 3,
          label: "External Invoice",
        },
        {
          value: 4,
          label: "MTO",
        },
      ],
      bankNameList: [],
      bookingId: 0,
      createdAppId: 0,
      createdBy: 0,
      membershipPaymentTypeList: [],
      setpaymentApprovalModalOpen: false,
      paymentReconcilationList: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        reconcilationStatus: "",
        filterDate: "",
        paymentCategory: "",
        searchByCompany: "",
        selectedPaymentCategory: [],
      },
      totalResultes: "",
      isLoading: false,

      singlePaymentProofDetails: {
        paymentList: [],
        reconciliationTotalAmount: 0,
        filePath: "",
        statusName: "",
        bookingId: 0,
        corporateMemberId: 0,
        paymentCategory: "",
        financeAdhocInvoiceId: 0,
        comments: "",
      },
      paymentProofApproveDetails: {
        paymentProofId: 0,
        bookingId: 0,
        amountCollected: "",
        bankInformationName: "DBS Bank",
        bankInformationNameId: 1,
        amountCollectedDate: "",
        admincomments: "",
      },
      setModal: false,
      outstandingInvoicesRequest: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        SearchInvoiceNumber: "",
      },
      actionDropdown: ["Update", "Send Reminder Mail", "Seat Release"],

      outstandingInvoicesList: [],
      totalOutstandingInvoicesListCount: 0,
      outstandingInvoiceDeatilsModal: false,
      singleOutstandingInvoiceDetails: {
        membershipPaymentId: "",
        financeAdhocInvoiceId: "",
        bookingId: "",
        membershipPaymentTypeId: "",
        invoiceNo: "",
        paymentVia: "",
        amount: "",
        status: "",
        invoiceGenerationDate: "",
        corporateMemberId: "",
        IndividualMemberId: "",
        eventId: "",
        filePath: "",
        comments: "",
        fileDisplayName: "",
        isCorporateBooking: false,
      },
      validationRule: {
        amountCollected: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "amount"
            ),
          },
        ],
        amountCollectedDate: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "payment received date"
            ),
          },
          {
            type: "isMaxDate",
            message:
              "The Amount Collected Date should not be greater than today’s date.",
          },
        ],
        admincomments: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "comments"
            ),
          },
        ],
      },
      validationRule1: {
        comments: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "comments for payment"
            ),
          },
        ],
        paymentVia: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "payment method"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      isPaidTotalPrice: false,
      isLoader: false,
      onAddLoader: false,
      filteredPaymentProofList: [],
      paymentsMethods: [
        {
          id: 2,
          name: "Pay Now",
        },
        {
          id: 3,
          name: "Internet Bank Transfer",
        },
        {
          id: 4,
          name: "Cheque",
        },
        {
          id: 5,
          name: "Nets Payment",
        },
      ],
      paymentViaId: 0,
      reconciliationAmount: 0,
    };
  }
  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination }, () => {
      this.getEventPaymentReconcilationList(newPagination);
    });
  };
  downloadPaymentApprovalProof = () => {
    this.setState({ isLoadingPdf: true });
    let request = [
      "PaymentImages",
      this.state.singlePaymentProofDetails.filePath,
    ];
    this.commonServices.GetPaymentFiles(request).then((response) => {
      if (response.data != null && response.status === 200) {

        var formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
        var filename = "";
        filename = `${"Paymentproof-"}${formattedDate}`;
        const extension = this.state.singlePaymentProofDetails.filePath
          .split(".")
          .pop();
        if (extension) {
          saveAs(new Blob([response.data]), `${filename}.${extension}`);
        }
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoadingPdf: false });
    });
  };
  actions = (element, index, value) => {
    return element !== "paymentProofId" ? null : (
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap pointer">
        <div className="grid grid-cols-2 gap-4">
          <div className="flex items-center relative">
            <button
              className="action-btn mr-4 flex items-center"
              aria-controls="add-edit-modal"
              onClick={(e) => this.openApprovalModal(e, value)}
            >
              {this.state.paymentReconcilationList[index]
                .paymentProofStatusId === 3 ||
                this.state.paymentReconcilationList[index]
                  .paymentProofStatusId === 4 ? (
                <p className="ml-2 tool-tip-txt underline text-[#81a3b8]">
                  View
                </p>
              ) : (
                <p className="ml-2 tool-tip-txt underline text-[#81a3b8]">
                  Approve
                </p>
              )}
            </button>
          </div>

          <div>
            {
              (this.state.paymentReconcilationList[index]
                .paymentProofStatusId === 3 &&
                (this.state.paymentReconcilationList[index].paidPrice ===
                  null ||
                  this.state.paymentReconcilationList[index].paidPrice ===
                  0)) ||
                (this.state.paymentReconcilationList[index]
                  .paymentProofStatusId !== 3 &&
                  this.state.paymentReconcilationList[index]
                    .paymentProofStatusId !== 2) ? (
                <ActionDeleteButton
                  value={value}
                  id={index}
                  index={index}
                  onActionClick={this.onDelete}
                  text="Delete"
                />
              ) : null
            }
          </div>
        </div>
      </td>
    );
  };

  openApprovalModal = (e, value) => {
    this.resetPaymentProofDetails();
    let paymentReconcilationArray = [...this.state.paymentReconcilationList];
    let found = {
      ...paymentReconcilationArray.find((x) => x.paymentProofId === value),
    };
    if (found) {
      this.getPaymentProofListDetailsByPaymentProofId(found, e);
    }
  };

  getPaymentProofListDetailsByPaymentProofId = (found, e) => {
    let request = [found.paymentProofId, found.membershipPaymentTypeId];
    this.BookingServices.getPaymentProofListDetailsByPaymentProofId(
      request
    ).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        if (response.responseItem.responseContent != null) {
          this.setState(
            {
              filteredPaymentProofList: response.responseItem.responseContent
                ? response.responseItem.responseContent
                : [],
            },
            () => {
              if (found) {
                let allPaymentList = [];
                this.state.filteredPaymentProofList.forEach(
                  (paymentProofObj, paymentProofIndex) => {
                    let paymentList = {
                      ...this.state.filteredPaymentProofList[paymentProofIndex]
                        .paymentList,
                    };
                    if (
                      paymentList[0].amountCollected !== null &&
                      paymentList[0].amountCollectedDate !== null
                    ) {
                      allPaymentList.push(paymentList[0]);
                      found.paidPrice =
                        found.paidPrice + paymentProofObj.paidPrice;
                    }
                  }
                );

                let tempPaymentList = found.paymentList;
                if (
                  tempPaymentList[0].amountCollected != null &&
                  tempPaymentList[0].amountCollectedDate != null
                ) {
                  found.paymentList = found.paymentList.concat(allPaymentList);
                } else {
                  found.paymentList = allPaymentList;
                }

                this.setState({ singlePaymentProofDetails: found }, () => {
                  e.stopPropagation();
                  this.setState({ setpaymentApprovalModalOpen: true });
                });
              }
            }
          );
        }
      } else {
        this.swalServices.Error(response.message);
        return [];
      }
    });
  };

  isValidDate(dateStr) {
    // Match YYYY-MM-DD format
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateStr)) return false;

    const [year, month, day] = dateStr.split("-").map(Number);

    if (year < 1000 || year > 9999) return false;

    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return false;

    return (
      dateObj.getFullYear() === year &&
      dateObj.getMonth() + 1 === month &&
      dateObj.getDate() === day
    );
  }

  getEventPaymentReconcilationList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });

    let request = {};
    let isValidDate_ = false;
    request.pageNo = pagination.pageNo;
    request.pageSize = pagination.pageSize;
    request.orderByColumn = pagination.orderByColumn;
    request.orderFlag = pagination.orderFlag;
    request.searchText = pagination.searchText;
    request.reconcilationStatus = pagination.reconcilationStatus;
    request.filterDate = pagination.filterDate;
    request.paymentCategory = pagination.paymentCategory;
    request.searchByCompany = pagination.searchByCompany;
    if (pagination.filterDate !== null && pagination.filterDate !== "") {
      isValidDate_ = this.isValidDate(pagination.filterDate);
    } else {
      isValidDate_ = true;
    }
    //

    if (!isValidDate_) {
      request.filterDate = "";
      this.swalServices.Error("Invalid date format. Please check.");
    }
    //
    this.BookingServices.getEventPaymentReconcilationList(request).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let details = response.responseItem.responseContent.itemList;
          details.map((key, index) => {
            key.registrationDate = moment(key.registrationDate).format(
              "DD MMM YYYY"
            );
            if (key.organisationUEN === null || key.organisationUEN === "") {
              key.organisationUEN = "-";
            }
            if (key.organisationName === null || key.organisationName === "") {
              key.organisationName = "-";
            }

            key.reconciliationAmount = `$${parseFloat(
              key.reconciliationTotalAmount
            ).toFixed(2)}`;

            return key;
          });

          this.setState({
            paymentReconcilationList: details,
            totalResultes: response.responseItem.responseContent.totalCount,
          });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      }
    );
  };

  onDelete = (value) => {
    let request = {
      id: value,
      deletedBy: this.state.createdBy,
      appId: this.state.createdAppId,
    };
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace(
          "{0}",
          "Payment Reconciliation"
        ),
        CommonSuccessMessages.Confirm_Delete.replace(
          "{0}",
          "payment reconciliation"
        ),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.BookingServices.deleteEventPaymentReconcilation(request).then(
            (response) => {
              if (response.statusCode === 200) {
                this.swalServices.Success("Delete successfully");
                this.getEventPaymentReconcilationList();
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoading: false });
            }
          );
        }
      });
  };

  componentDidMount() {
    this.getAllDropDownForEntryManagement();
    const audit = getAuditContext()
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId })
  }

  savePaymentReconcilationDetailsByAdmin = () => {
    const audit = getAuditContext()
    let req = {};
    req.paymentProofId = this.state.singlePaymentProofDetails.paymentProofId;
    req.bookingId = this.state.singlePaymentProofDetails.bookingId;
    req.corporateMemberId = this.state.singlePaymentProofDetails.memberId;
    req.amountCollected = this.state.paymentProofApproveDetails.amountCollected;
    req.adminComments = this.state.paymentProofApproveDetails.admincomments;
    req.amountCollectedDate =
      this.state.paymentProofApproveDetails.amountCollectedDate;
    req.updatedAppId = audit.appId;
    req.updatedAt = new Date();
    req.updatedBy = audit.adminUserId;
    req.bankInformationName = "DBS Bank";
    req.bankInformationId = this.state.paymentProofApproveDetails
      .bankInformationNameId
      ? this.state.paymentProofApproveDetails.bankInformationNameId
      : 1;
    if (this.isValidateAllFields()) {
      let collectedAmount = 0;
      if (this.state.singlePaymentProofDetails?.paymentList) {
        this.state.singlePaymentProofDetails.paymentList.forEach((element) => {
          collectedAmount += element.amountCollected;
        });
      }
      this.setState({ onAddLoader: true });
      this.BookingServices.savePaymentReconcilationDetailsByAdmin(req).then(
        (response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            if (response.responseItem.responseContent != null) {
              this.setState({ setpaymentApprovalModalOpen: false }, () => {
                this.resetPaymentProofDetails();
                this.getEventPaymentReconcilationList();
                this.setState({ onAddLoader: false });
              });
              this.swalServices.Success(
                "Payment reconciliation details inserted successfully."
              );
            }
          } else {
            this.swalServices.Error(response.message);
          }
        }
      );
    }
  };

  acceptTotalPaidAmountInReconcilation = (
    bookingId,
    corporateId,
    paymentCategoryId,
    financeAdhocInvoiceId,
    createdAppId,
    createdBy
  ) => {
    this.setState({ isLoader: true });
    //EVENT
    let request = [bookingId, createdAppId, createdBy]
    if (paymentCategoryId === 4) {
      this.BookingServices.acceptTotalPaidAmountInReconcilation(request).then(
        (response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            if (response.responseItem.responseContent != null) {
              this.setState({ setpaymentApprovalModalOpen: false }, () => {
                this.resetPaymentProofDetails();
                this.getEventPaymentReconcilationList();
              });
              this.swalServices.Success(
                "Payment reconciliation details inserted successfully."
              );
            }
          } else {
            this.swalServices.Error(response.message);
          }
          this.setState({ isLoader: false });
        }
      );
    }
    //EXTERNAL INVOICE
    else if (paymentCategoryId === 5) {
      this.BookingServices.acceptTotalExternalInvoicePaidAmountInReconciliation(
        financeAdhocInvoiceId
      ).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          if (response.responseItem.responseContent != null) {
            this.setState({ setpaymentApprovalModalOpen: false }, () => {
              this.resetPaymentProofDetails();
              this.getEventPaymentReconcilationList();
            });
            this.swalServices.Success(
              "Payment reconciliation details inserted successfully."
            );
          }
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoader: false });
      });
    }
  };

  getAllDropDownForEntryManagement = () => {
    this.entryServices.getAllDropDownForEntryManagement(0).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let bankList = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "BankNames"
        );
        let membershipPaymentTypeList =
          response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "MembershipPaymentType"
          );
        bankList = bankList.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        membershipPaymentTypeList = membershipPaymentTypeList.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState(
          {
            bankNameList: bankList,
            membershipPaymentTypeList: membershipPaymentTypeList,
          },
          () => this.getEventPaymentReconcilationList()
        );
      } else {
        this.getEventPaymentReconcilationList();
        this.swalServices.Error(response.message);
      }
    });
  };

  isValidateAllFields = () => {
    const newValidState = isValidForm(
      this.state.paymentProofApproveDetails,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.paymentProofApproveDetails,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };

  handleChange(event, identity) {
    const value = event.target.value;
    const name = event.target.name;

    if (identity === "paymentProofApproveDetails") {
      let detail = { ...this.state.paymentProofApproveDetails };
      if (name === "amountCollected") {
        detail[name] = value;
      } else {
        detail[name] = value;
      } this.setState({ paymentProofApproveDetails: detail });
    }
    if (identity === "pagination") {
      let page = { ...this.state.pagination };
      page.pageNo = 1;
      page[name] = value;
      this.setState({ pagination: page });
    }
    if (identity === "searchCompany") {
      let detail = { ...this.state.outstandingInvoicesRequest };
      detail[name] = value;
      this.setState({ outstandingInvoicesRequest: detail });
    }
  }

  handleChangeInDropdown = (selected, drpIdentity) => {
    let detail = this.state.paymentProofApproveDetails;
    let page = this.state.pagination;
    if (drpIdentity === "BankName") {
      detail.bankInformationNameId = selected.value;
      if (selected.value === 0) {
        detail.bankInformationName = "";
      } else {
        detail.bankInformationName = selected.label;
      }
      this.setState({ paymentProofApproveDetails: detail });
      // this.validateField("bankInformationName");
    } else if (drpIdentity === "PaymentCategory") {
      if (selected.value === 0) {
        page.paymentCategory = "Event";
      } else {
        let selectedPaymentCategory = [];
        let commaSeparatedString = "";
        selected.forEach((selectedObj, selectedObjIndex) => {
          switch (selectedObj.label) {
            case "Event":
              selectedPaymentCategory.push(4);
              break;
            case "Membership":
              selectedPaymentCategory.push(1);
              selectedPaymentCategory.push(3);
              break;
            case "MTO":
              selectedPaymentCategory.push(2);
              break;
            case "External Invoice":
              selectedPaymentCategory.push(5);
              break;
            default:
              selectedPaymentCategory.push(3);
          }
        });
        if (selectedPaymentCategory.length > 0) {
          commaSeparatedString = selectedPaymentCategory.join([","]);
        }
        page.paymentCategory = commaSeparatedString;
        page.selectedPaymentCategory = selected;
      }
      this.setState({ pagination: page });
    } else if (drpIdentity === "PaymentStatus") {
      if (selected.value === 0) {
        page.reconcilationStatus = "";
      } else {
        page.reconcilationStatus = selected.label;
      }
      this.setState({ pagination: page }, () => {
        this.filterSearch();
      });
    }
  };

  filterSearch = () => {
    this.getEventPaymentReconcilationList(this.state.pagination);
  };

  resetPaymentProofDetails = () => {
    let resetvalidState = {
      isValid: true,
      error: {},
    };
    let reset = this.state.paymentProofApproveDetails;
    let reset2 = this.state.singlePaymentProofDetails;
    reset.paymentProofId = 0;
    reset.bookingId = 0;
    reset.amountCollected = "";
    reset.admincomments = "";
    reset.amountCollectedDate = "";
    reset.bankInformationName = "";
    reset.bankInformationNameId = 0;
    reset2.paymentList = [];
    reset2.totalPrice = 0;
    reset2.filePath = "";
    this.setState({
      paymentProofApproveDetails: reset,
      singlePaymentProofDetails: reset2,
      validState: resetvalidState,
    });
  };

  getOutstandingInvoicesList = (
    outstandingInvoicesRequest = this.state.outstandingInvoicesRequest
  ) => {
    this.setState({ isLoading: true });
    this.BookingServices.getOutstandingInvoicesList(
      outstandingInvoicesRequest
    ).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let details = response.responseItem.responseContent.itemList;
        details.map((key, index) => {
          key.invoiceGenerationDate = key.invoiceGenerationDate
            ? moment(key.invoiceGenerationDate).format("DD MMM YYYY")
            : "-";
          key.invoiceNo = key.invoiceNo ? key.invoiceNo : "-";
          key.organisationName = key.organisationName
            ? key.organisationName
            : "-";
          return key;
        });
        this.setState({
          outstandingInvoicesList: details,
          totalOutstandingInvoicesListCount:
            response.responseItem.responseContent.totalCount,
        });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };

  openOutstandingModal = () => {
    this.setState({ setModal: true }, () => {
      this.getOutstandingInvoicesList();
    });

  };

  setPaginationForOutstanding = (newPagination) => {
    this.setState({ outstandingInvoicesRequest: newPagination }, () => {
      this.getOutstandingInvoicesList(newPagination);
    });
  };

  actionsForemail = (columnName, rowIndex, cellValue) => {
    if (columnName !== "bookingId") return null;

    const row = this.state.outstandingInvoicesList[rowIndex];
    const bookingId = row?.bookingId;

    return (
      <td>
        <ActionContainer>
          <DropdownAction
            key={rowIndex}
            index={rowIndex}
            value={bookingId}
            options={this.state.actionDropdown}
            align="right"
            onOptionClick={this.actionClick.bind(this)}
          />
        </ActionContainer>
      </td>
    );
  };

  actionClick = (index, value, option) => {
    if (value && value > 0 && option === "Update") {
      this.openOutstandingDetaisModal(value);
    }
    if (value && value > 0 && option === "Send Reminder Mail") {
      this.sendMailToOutStandingInvoiceById(value);
    }
    if (value && value > 0 && option === "Seat Release") {
      this.SendMailToSeatreleaseById(value);
    }
  };

  sendMailToOutStandingInvoiceById = (bookingId) => {
    this.BookingServices.sendMailToOutStandingInvoiceById(bookingId).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.swalServices.Success("Reminder Mail Sent Successfully!!");
        } else {
          this.swalServices.Error(response.message);
        }
      }
    );
  };

  SendMailToSeatreleaseById = (bookingId) => {
    this.BookingServices.sendMailToSeatreleaseById(bookingId).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.swalServices.Success("Seat Release Mail Sent Successfully!!");
          this.getOutstandingInvoicesList();
        } else {
          this.swalServices.Error(response.message);
        }
      }
    );
  };

  openOutstandingDetaisModal = (value) => {
    let details = [...this.state.outstandingInvoicesList];
    let found = { ...details.find((x) => x.bookingId === value) };
    if (found) {
      let paymentid = this.state.paymentsMethods.find(
        (x) => x.name === found.paymentVia
      );
      found.paymentVia = paymentid?.name ? paymentid.name : "";
      found.bookingId = value;
      this.setState({
        singleOutstandingInvoiceDetails: found,
        paymentViaId: paymentid?.id ? paymentid.id : 0,
        validState: {
          isValid: true,
          error: {},
        },
      });
      this.setState({ outstandingInvoiceDeatilsModal: true });
    }
  };

  onFileChange = (event) => {
    const file = event.target.files[0];

    // Reset input immediately so the same file can be re-selected
    event.target.value = "";

    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    const allowedExtensions = [
      ".pdf",
      ".docx",
      ".jpg",
      ".jpeg",
      ".png"
    ];
    const extension = file ? file.name.substring(file.name.lastIndexOf(".")).toLowerCase() : "";
    if (file && allowedTypes.includes(file.type) && allowedExtensions.includes(extension)) {
      let request = {};
      request.storagePath = "PaymentImages";
      request.file = file;
      request.fileName = file.name;

      this.commonServices.uploadPDF(request).then((response) => {
        if (response != null) {
          if (request.storagePath === "PaymentImages") {
            let detail = { ...this.state.singleOutstandingInvoiceDetails };
            detail["filePath"] = response.fileName;
            detail["fileDisplayName"] = file.name;

            this.setState({ singleOutstandingInvoiceDetails: detail }, () => {
              this.swalServices.Success("File Uploaded");
            });
          }
        } else {
          this.swalServices.Error(response.message);
        }
      });
    } else {
      this.swalServices.Error("Please select Image Pdf and Docx File");
    }
  };

  handleChangeComments(event, identity) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = { ...this.state.singleOutstandingInvoiceDetails };
    detail[name] = value;
    this.setState({ singleOutstandingInvoiceDetails: detail });
  }

  addProofInPaymentProofMapping = () => {
    let isValidInput = this.isValidateAllFieldsOutstandingDetails();
    if (isValidInput) {
      this.setState({ isOutstandingRecordLoading: true });
      let detail = { ...this.state.singleOutstandingInvoiceDetails };
      detail.paymentProofStatusId = 1;
      detail.bookingId = detail.bookingId ? detail.bookingId : detail.membershipPaymentId;
      this.BookingServices.addProofInPaymentProofMapping(detail).then(
        (response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            this.swalServices.Success(response.message);
            this.setState({ outstandingInvoiceDeatilsModal: false, isOutstandingRecordLoading: false }, () => {
              this.getOutstandingInvoicesList();
              this.reset();
            });
          } else {
            this.swalServices.Error(response.message);
          }
          this.setState({ isOutstandingRecordLoading: false });
        }
      );
    }
  };

  reset = () => {
    let details = this.state.singleOutstandingInvoiceDetails;
    details.membershipPaymentId = "";
    details.financeAdhocInvoiceId = "";
    details.bookingId = "";
    details.membershipPaymentTypeId = "";
    details.invoiceNo = "";
    details.paymentVia = "";
    details.amount = "";
    details.status = "";
    details.invoiceGenerationDate = "";
    details.corporateMemberId = "";
    details.IndividualMemberId = "";
    details.eventId = "";
    details.filePath = "";
    details.comments = "";
    details.fileDisplayName = "";
    this.setState({ singleOutstandingInvoiceDetails: details });
  };
  validateFieldOutstandingDetails = (key) => {
    const newValidState = validate(
      key,
      this.state.singleOutstandingInvoiceDetails,
      this.state.validationRule1,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };

  isValidateAllFieldsOutstandingDetails = () => {
    const newValidState = isValidForm(
      this.state.singleOutstandingInvoiceDetails,
      this.state.validationRule1,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };
  setFilterParameters = (id, drpIdentity) => {
    if (drpIdentity === "PaymentVia") {
      let data = { ...this.state.singleOutstandingInvoiceDetails };
      let found = this.state.paymentsMethods.find((x) => x.id === id);
      if (found) {
        data["paymentVia"] = found.name;
        this.setState(
          { paymentViaId: id, singleOutstandingInvoiceDetails: data },
          () => {
            this.validateFieldOutstandingDetails("paymentVia");
          }
        );
      } else {
        data["paymentVia"] = "";
        this.setState(
          { paymentViaId: 0, singleOutstandingInvoiceDetails: data },
          () => {
            this.validateFieldOutstandingDetails("paymentVia");
          }
        );
      }
    }
  };

  uploadReconciliationExcel = (e) => {
    const file = e.target.files[0];
    if (
      file &&
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      let details = {};
      if (
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        details.fileTypeExtension = ".xlsx";
      } else if (file.type === "application/vnd.ms-excel") {
        details.fileTypeExtension = ".xls";
      } else if (file.type === "text/csv") {
        details.fileTypeExtension = ".csv";
      }
      details["file"] = e.target.files[0];
      details.fileName = file.name;
      this.setState({ uploadFileDetails: { ...details } });
      this.swalServices
        .Confirm(
          "File",
          "Confirm to upload " + details.fileName + "?",
          "Yes",
          "no"
        )
        .then((res) => {
          if (res) {
            this.setState({ isExceluploading: true });
            this.commonServices
              .uploadReconciliationExcel(details)
              .then((response) => {
                if (
                  response.statusCode === 200 &&
                  response.responseItem != null &&
                  response.responseItem.responseContent.hasError !== true
                ) {
                  this.swalServices.Success("Records inserted successfully.");
                  this.setState({ isExceluploading: false });
                } else if (
                  response.responseItem.responseContent.hasError === true &&
                  response.responseItem.responseContent.errorType ===
                  "Invalid Column"
                ) {
                  this.swalServices.Error(
                    "Invalid File, " +
                    response.responseItem.responseContent.errorMessage
                  );
                  this.setState({ isExceluploading: false });
                } else {
                  this.swalServices.Error("File already exists.");
                  this.setState({ isExceluploading: false });
                }
              });
          }
        });
    } else {
      this.swalServices.Error("Invalid file type");
    }
  };
  downloadReconciliationExcelTemplate = () => {
    this.BookingServices.downloadReconciliationExcelTemplate([]).then(
      (response) => {
        if (response.status === 200 && response.data != null) {
          let blob = new Blob([response.data]);
          saveAs(blob, `ReconciliationTemplate.xlsx`);
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      }
    );
  };
  render() {
    return (
      <div className="main-body-section finance-body-sec">
        <div className="bg-white">
          <div className="grid grid-cols-12 gap-6 w-full items-center px-8 pt-6 pb-12">
            <div className="2xl:col-span-4 lg:col-span-4 col-span-12 w-full xl:pr-14">
              <h2 className="text-xl theme-color mb-3">Search Invoice</h2>
              <input
                id="default"
                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                type="text"
                name="searchText"
                value={this.state.pagination.searchText}
                onChange={(e) => this.handleChange(e, "pagination")}
              />
            </div>
            <div className="2xl:col-span-4 lg:col-span-4 col-span-12 w-full xl:pr-14">
              <h2 className="text-xl theme-color mb-3">Search Registrant</h2>
              <input
                id="default"
                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                type="text"
                name="searchByCompany"
                value={this.state.pagination.searchByCompany}
                onChange={(e) => this.handleChange(e, "pagination")}
              />
            </div>
            <div className="2xl:col-span-4 lg:col-span-4 col-span-12 w-full xl:pr-14">
              <h2 className="text-xl theme-color mb-3">Status</h2>
              <div className="with-border-line w-full">
                <Selector
                  options={this.state.statusList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={this.handleChangeInDropdown.bind(this)}
                  allowSelectAll={false}
                  value={this.state.statusList.find(
                    (item) =>
                      item.label === this.state.pagination.reconcilationStatus
                  )}
                  drpIdentity="PaymentStatus"
                />
              </div>
            </div>
            <div className=" 2xl:col-span-3 lg:col-span-3 col-span-12 w-full xl:pr-14">
              <h2 className="text-xl theme-color mb-3">Date</h2>
              <input
                id="default"
                name="filterDate"
                className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                type="date"
                value={this.state.pagination.filterDate}
                onChange={(e) => this.handleChange(e, "pagination")}
              />
            </div>

            <div className="2xl:col-span-2 lg:col-span-2 col-span-12 w-full">
              <div className="pt-7 flex items-center justify-end w-full">
                {this.state.isExceluploading ? (
                  <button
                    className="btn btn-red text-xl border text-white opacity-99 cursor-not-allowed"
                    disabled
                  >
                    Search
                  </button>
                ) : (
                  <button
                    className="btn btn-red text-xl border text-white "
                    onClick={() => this.filterSearch()}
                  >
                    Search
                  </button>
                )}
              </div>
            </div>

            <div className="2xl:col-span-12 pt-10 lg:col-span-12 col-span-12 w-full">
              <div className=" flex  items-center justify-end w-full">
                {this.state.isExceluploading ? (
                  <button
                    className="btn  btn-red text-xl border text-white opacity-99 cursor-not-allowed"
                    disabled
                  >
                    Add Records
                  </button>
                ) : (
                  <button
                    className="btn  btn-red text-xl border text-white "
                    onClick={(e) => {
                      this.openOutstandingModal();
                    }}
                  >
                    Add Records
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 payment-reconcilation-tble">
          <Table
            columns={[
              { name: "registrationDate", title: "Registration Date" },
              { name: "reconciliationInvoiceNo", title: "Invoice No" },
              { name: "eventName", title: "Event Name" },
              { name: "reconciliationAmount", title: "Payment Amount" },
              { name: "contactPerson", title: "Registrant" },
              { name: "paymentVia", title: "Payment Via" },
              { name: "paymentProofStatus", title: "Status" },
              { name: "paymentProofId", title: "Action" },
            ]}
            rows={this.state.paymentReconcilationList}
            isLoading={this.state.isLoading}
            sortingColumns={[
              "registrationDate",
              "reconciliationInvoiceNo",
              "organisationName",
              "organisationUEN",
              "paymentProofStatus",
            ]}
            pagination={this.state.pagination}
            totalResultes={this.state.totalResultes}
            totalCount={this.state.totalResultes}
            setPagination={this.setPagination.bind(this)}
            customScope={[
              {
                column: "paymentProofId",
                renderTableData: this.actions.bind(this),
              },
            ]}
          />
        </div>

        <div className="payment-view-approve-modal">
          <ModalBasic
            id="paymentviewapprove"
            modalOpen={this.state.setpaymentApprovalModalOpen}
            setModalOpen={() =>
              this.setState({ setpaymentApprovalModalOpen: false }, () => {
              })
            }
            title="Payment Approval"
          >
            <div className="md:px-10 p-4 md:py-7 border-t border-[#757575]-300 bg-white body-sec-approve">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12 border-b-2 border-[#757575]-300 md:pb-14 pb-5">
                  <div className="flex items-center justify-between">
                    <h2 className="text-xl font-bold">
                      {(() => {
                        const filePath =
                          this.state.singlePaymentProofDetails.filePath;
                        const fileExtension = filePath
                          ?.split(".")
                          .pop()
                          ?.toLowerCase();

                        if (
                          ["jpg", "jpeg", "png", "gif"].includes(fileExtension)
                        ) {
                          return "Image Proof";
                        } else if (["pdf", "docx"].includes(fileExtension)) {
                          return "Download file to see payment proof";
                        }
                      })()}
                    </h2>

                    <div className="download-icon">
                      <button
                        className="flex items-center btn btn-red text-white"
                        onClick={async () => {
                          try {
                            const response = await fetch(
                              APIURL +
                              GetImage +
                              "?type=PaymentImages&&fileName=" +
                              this.state.singlePaymentProofDetails.filePath
                            );
                            const blob = await response.blob();
                          } catch (error) {
                            console.error(
                              "Error downloading the image:",
                              error
                            );
                          }
                        }}
                      >
                        <span
                          className="font-bold text-xl"
                          onClick={() => this.downloadPaymentApprovalProof()}
                        >
                          Download
                        </span>
                        <img
                          className="w-6 pl-2"
                          src="../download-icon-white.png"
                          alt=""
                        ></img>
                      </button>
                    </div>
                  </div>
                  <div className="payment-img mt-2">
                    {(() => {
                      const filePath =
                        this.state.singlePaymentProofDetails.filePath;
                      const fileExtension = filePath
                        ?.split(".")
                        .pop()
                        ?.toLowerCase();
                      const fileName = filePath?.split("/").pop();

                      if (
                        ["jpg", "jpeg", "png", "gif"].includes(fileExtension)
                      ) {
                        return (
                          <img
                            className="cursor-pointer max-h-96"
                            alt="Preview"
                            src={`${APIURL + GetImage
                              }?type=PaymentImages&&fileName=${filePath}`}
                          />
                        );
                      } else {
                        return (
                          <div className="text-base font-medium text-[#333]">
                            {fileName}
                          </div>
                        );
                      }
                    })()}
                  </div>
                  <div className="col-span-10">
                    <h2 className="text-xl theme-color font-bold mb-3 pt-4">
                      Comments : {this.state.singlePaymentProofDetails.comments}
                    </h2>
                  </div>
                </div>
                <div className="col-span-12">
                  {this.state.singlePaymentProofDetails.paymentProofStatusId ===
                    3 ||
                    this.state.singlePaymentProofDetails.paymentProofStatusId ===
                    2 ? null : (
                    <div className="grid grid-cols-12 gap-6">
                      <div className="2xl:col-span-6 lg:col-span-6 col-span-12 w-full">
                        <h2 className="text-xl theme-color mb-3">
                          Bank Information
                        </h2>
                        <div className="with-border-line w-full">
                          <Selector
                            options={this.state.bankNameList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={this.handleChangeInDropdown.bind(this)}
                            allowSelectAll={false}
                            value={this.state.bankNameList.filter(
                              (item) =>
                                item.label ===
                                this.state.paymentProofApproveDetails
                                  .bankInformationName
                            )}
                            drpIdentity="BankName"
                          />

                          <div>
                          </div>
                        </div>
                      </div>
                      <div className="2xl:col-span-4 lg:col-span-4 col-span-12 w-full">
                        <h2 className="text-xl theme-color mb-3">
                          Amount Collected{" "}
                          <span className="text-[#e5322b]">*</span>
                        </h2>
                        <div className="with-border-line w-full">
                          <input
                            className="form-input rounded-none w-full shadow-red py-3 text-lg"
                            type="number"
                            name="amountCollected"
                            min="0"
                            pattern="^[0-9]+$"
                            inputmode="numeric"
                            required
                            value={
                              this.state.paymentProofApproveDetails
                                .amountCollected
                            }
                            onChange={(e) =>
                              this.handleChange(e, "paymentProofApproveDetails")
                            }
                            onBlur={() => this.validateField("amountCollected")}
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "+") {
                                e.preventDefault();
                              }
                            }}
                          ></input>
                          <div>
                            <ValidationText
                              error={
                                this.state.validState.error.amountCollected
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="2xl:col-span-4 lg:col-span-4 col-span-12 w-full">
                        <h2 className="text-xl theme-color mb-3">
                          Comments<span className="text-[#e5322b]">*</span>
                        </h2>
                        <div className="with-border-line w-full">
                          <input
                            className="form-input rounded-none w-full shadow-red py-3 text-lg"
                            type="text"
                            name="admincomments"
                            value={
                              this.state.paymentProofApproveDetails
                                .admincomments
                            }
                            onChange={(e) =>
                              this.handleChange(e, "paymentProofApproveDetails")
                            }
                            onBlur={() => this.validateField("admincomments")}
                          ></input>
                          <div>
                            <ValidationText
                              error={this.state.validState.error.admincomments}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="2xl:col-span-4 lg:col-span-4 col-span-12 w-full">
                        <h2 className="text-xl theme-color mb-3">
                          Amount Collected Date
                          <span className="text-[#e5322b]">*</span>
                        </h2>
                        <input
                          id="amountCollectedDate"
                          className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                          type="date"
                          name="amountCollectedDate"
                          value={moment(
                            this.state.paymentProofApproveDetails
                              .amountCollectedDate
                          ).format("yyyy-MM-DD")}
                          onChange={(e) =>
                            this.handleChange(e, "paymentProofApproveDetails")
                          }
                          onBlur={() =>
                            this.validateField("amountCollectedDate")
                          }
                        />
                        <div>
                          <ValidationText
                            error={
                              this.state.validState.error.amountCollectedDate
                            }
                          />
                        </div>
                      </div>
                      <div className="2xl:col-span-2 lg:col-span-2 col-span-12 w-full">
                        <div className="pt-11 flex items-center justify-end w-full">
                          {this.state.onAddLoader ? (
                            <ButtonLoader className="buttonload group relative flex items-center justify-center btn btn-red px-[20px] text-white focus:outline-none" />
                          ) : (
                            <button
                              className="btn btn-red text-xl border text-white "
                              onClick={() =>
                                this.savePaymentReconcilationDetailsByAdmin()
                              }
                            >
                              Add
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="grid grid-cols-12 gap-6 md:mt-7 md:mb-5 mt-0">
                    <div className="col-span-12">
                      <div className="col-span-12 flex justify-between items-center">
                        <h2 className="text-xl theme-color font-bold mb-3">
                          Total Amount:{" "}
                          {`$${this.state.singlePaymentProofDetails
                            .reconciliationTotalAmount
                            ? parseFloat(
                              this.state.singlePaymentProofDetails
                                .reconciliationTotalAmount
                            ).toFixed(2)
                            : "0.00"
                            }`}
                        </h2>
                        <h2 className="text-xl theme-color font-bold mb-3">
                          Shortfall Amount:{" "}

                          {`$${this.state.singlePaymentProofDetails.shortfallAmount && parseFloat(this.state.singlePaymentProofDetails.shortfallAmount) > 0 ? parseFloat(this.state.singlePaymentProofDetails.shortfallAmount).toFixed(2) : "0.00"}`}

                        </h2>
                      </div>
                      <div className="payment-approval-table">
                        <table className="">
                          <thead>
                            <tr className="">
                              <th className="">
                                <div className="">Date</div>
                              </th>
                              <th className="">
                                <div className="">Bank Information</div>
                              </th>
                              <th className="">
                                <div className="">
                                  Amount Collected <span> *</span>
                                </div>
                              </th>
                              <th className="">
                                <div className="">Comments</div>
                              </th>
                            </tr>
                          </thead>

                          <tbody className="">
                            {this.state.singlePaymentProofDetails.paymentList
                              .length > 0 &&
                              this.state.singlePaymentProofDetails.paymentList.map(
                                (e, key) => {
                                  return (
                                    <tr key={key}>
                                      <td>
                                        {moment(e.amountCollectedDate).format(
                                          "DD MMM YYYY"
                                        )}
                                      </td>
                                      <td>{e.bankName ? e.bankName : ""}</td>
                                      <td>
                                        {e.amountCollected
                                          ? parseFloat(
                                            e.amountCollected
                                          ).toFixed(2)
                                          : "0.00"}
                                      </td>
                                      <td>{e.comments}</td>
                                    </tr>
                                  );
                                }
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="2xl:col-span-12 lg:col-span-12 col-span-12 w-full">
                      <div className="flex items-center justify-end w-full">
                        {this.state.singlePaymentProofDetails.paymentProofStatusId !== 3 ? (
                          <>
                            {this.state.singlePaymentProofDetails.paidPrice >= this.state.singlePaymentProofDetails.reconciliationTotalAmount ? (
                              <>
                                {this.state.isLoader === true ? (
                                  <ButtonLoader />
                                ) : (
                                  <>
                                    {this.state.singlePaymentProofDetails.membershipPaymentTypeId !== 3 ? (
                                      <button
                                        className="btn btn-red text-xl border text-white"
                                        onClick={() =>
                                          this.acceptTotalPaidAmountInReconcilation(
                                            this.state.singlePaymentProofDetails
                                              .bookingId,
                                            this.state.singlePaymentProofDetails
                                              .memberId,
                                            this.state.singlePaymentProofDetails
                                              .membershipPaymentTypeId,
                                            this.state.singlePaymentProofDetails
                                              .financeAdhocInvoiceId,
                                            this.state.createdAppId,
                                            this.state.createdBy
                                          )
                                        }
                                      >
                                        Accept
                                      </button>
                                    ) : null}
                                  </>
                                )}
                              </>
                            ) : null}
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBasic>

          <ModalBasic
            id="add-edit-modal"
            className="membership-add-edit-modal"
            modalOpen={this.state.setModal}
            setModalOpen={() => this.setState({ setModal: false })}
            title="Outstanding Invoices List"
          >
            <div className="add-record-popup-section">
              <div className="grid grid-cols-12 gap-6 w-full">
                <div className="2xl:col-span-4 lg:col-span-6 col-span-12">
                  <h2 className="text-xl theme-color mb-1">
                    Search By Invoice Number
                  </h2>
                  <input
                    id="default"
                    className="form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="text"
                    onChange={(e) => {
                      let data = { ...this.state.outstandingInvoicesRequest };
                      data.SearchInvoiceNumber = e.target.value;
                      data.pageNo = 1;
                      this.setState({ outstandingInvoicesRequest: data }, () =>
                        this.getOutstandingInvoicesList(data)
                      );
                    }}
                  />
                </div>
                <div className="2xl:col-span-4 lg:col-span-6 col-span-12">
                  <h2 className="text-xl theme-color mb-1">
                    Search Registrant
                  </h2>
                  <input
                    id="default"
                    className="form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="text"
                    onChange={(e) => {
                      let data = { ...this.state.outstandingInvoicesRequest };
                      data.searchText = e.target.value;
                      data.pageNo = 1;
                      this.setState({ outstandingInvoicesRequest: data }, () =>
                        this.getOutstandingInvoicesList(data)
                      );
                    }}
                  />
                </div>
              </div>
              <div className="mt-10 payment-reconcilation-tble">
                <Table
                  columns={[
                    { name: "InvoiceNo", title: "Invoice No" },
                    { name: "OrganisationName", title: "Registrant" },
                    { name: "PaymentVia", title: "Payment" },
                    { name: "Amount", title: "Total Amount" },
                    { name: "Status", title: "Status" },
                    { name: "InvoiceGenerationDate", title: "Date" },
                    { name: "bookingId", title: "Action" },
                  ]}
                  rows={this.state.outstandingInvoicesList}
                  isLoading={this.state.isLoading}
                  sortingColumns={["PaymentVia", "Amount"]}
                  pagination={this.state.outstandingInvoicesRequest}
                  totalResultes={this.state.totalOutstandingInvoicesListCount}
                  totalCount={this.state.totalOutstandingInvoicesListCount}
                  setPagination={this.setPaginationForOutstanding.bind(this)}
                  customScope={[
                    {
                      column: "bookingId",
                      renderTableData: this.actionsForemail.bind(this),
                    },
                  ]}
                />
              </div>
            </div>
          </ModalBasic>
          <div className="outstanding-invoice-detail-modal">
            <ModalBasic
              id="outstandingInvoices"
              modalOpen={this.state.outstandingInvoiceDeatilsModal}
              setModalOpen={() =>
                this.setState({ outstandingInvoiceDeatilsModal: false })
              }
              title="Outstanding Invoice Details"
            >
              <div className="grid grid-span-12 gap-6 p-5 pb-10">
                <div className="col-span-12 mb-5">
                  <div className="items-center mb-5">
                    <label className="text-[#757575] text-[16px] mobile-14 md:mb-2 inline-block">
                      File
                    </label>
                    <div className="flex items-center disabled-input">
                      <input
                        className="w-full custom-input"
                        type="text"
                        name=""
                        value={
                          this.state.singleOutstandingInvoiceDetails
                            .fileDisplayName
                            ? this.state.singleOutstandingInvoiceDetails
                              .fileDisplayName
                            : ""
                        }
                        disabled
                      />
                      <div>
                      </div>
                      <div className="flex items-center justify-center ml-4 ">
                        <form className="custom-uploader custom-file-upload-btn flex justify-center items-center text-center btn btn-red-border">
                          <label
                            htmlFor={`upload_File`}
                            className="text-uplod block text-sm text-[#e5322b] w-full whitespace-nowrap"
                          >
                            Select File
                          </label>
                          <input
                            className="sr-only"
                            id={`upload_File`}
                            type="file"
                            onChange={(event) => this.onFileChange(event)}
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="items-center mb-5">
                    <label className="text-[#757575] text-[16px] mobile-14 md:mb-2 inline-block">
                      Payment Method
                      <span className="text-[#e5322b]">*</span>
                    </label>
                    <DropdownSelect
                      drpIdentity={"PaymentVia"}
                      optionArray={this.state.paymentsMethods}
                      setFilterParameters={(id, drpIdentity) =>
                        this.setFilterParameters(id, drpIdentity)
                      }
                      value={this.state.paymentViaId}
                    />
                    <div>
                      <ValidationText
                        error={this.state.validState.error.paymentVia}
                      />
                    </div>
                  </div>
                  <div className="items-center">
                    <label className="text-[#757575] text-[16px] mobile-14 md:mb-2 inline-block">
                      Comments
                      <span className="text-[#e5322b]">*</span>
                    </label>
                    <textarea
                      className="w-full"
                      id=""
                      rows="5"
                      name="comments"
                      value={
                        this.state.singleOutstandingInvoiceDetails.comments
                      }
                      onChange={(e) => this.handleChangeComments(e)}
                      onBlur={() =>
                        this.validateFieldOutstandingDetails("comments")
                      }
                    />
                    <div>
                      <ValidationText
                        error={this.state.validState.error.comments}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-span-12 flex justify-center">
                  {this.state.isOutstandingRecordLoading ? <ButtonLoader /> :
                    <button
                      className="w-32 px-7 py-2 btn-sm btn-red text-lg text-white"
                      onClick={() => {
                        this.addProofInPaymentProofMapping();
                      }}
                    >
                      Save
                    </button>
                  }
                </div>
              </div>
            </ModalBasic>
          </div>
        </div>
      </div>
    );
  }
}
